<template>
  <li class="el-select-dropdown__item" :class="{ active }" @click="onClick">
    <slot></slot>
  </li>
</template>

<script>
export default {
  props: { active: Boolean },
  methods: {
    onClick(e) {
      this.$emit('click', e)
    }
  }
}
</script>

<style lang="css" scoped>
.active {
  font-weight: bold;
  color: #009688;
  background-color: #F5F7FA;
  cursor: no-drop;
}
</style>
